import { makeStyles } from "@mui/styles";

export const useStyles = makeStyles(({ palette, spacing }) => ({
  button: {
    "&:hover": {
      color: palette.primary.main,
      backgroundColor: "#D9DCF0",
      cursor: "pointer",
      textDecoration: "none",
    },
    alignItems: "center",
    backgroundColor: palette.primary.light,
    borderRadius: spacing(0.5),
    color: palette.primary.main,
    display: "flex",
    fontSize: 12,
    marginRight: spacing(1),
    padding: "6px 6px 6px 6px",
    transition: "background-color .3s ease-out",
  },
  icon: {
    height: spacing(2),
    marginLeft: spacing(-0.5),
  },
}));
